import React from 'react';
import { observer } from 'mobx-react-lite';
import { EnvBar } from '../atoms';
import { useRootStore } from '../../App';

export const EnvColorBar = observer(() => {
  const root = useRootStore();
  const { env, abTag, appVersion } = root.appStore;
  const { user } = root.userStore;

  return (
    <EnvBar env={env}>
      appVersion:
      <span style={{ margin: '0 5px' }}>{JSON.stringify(appVersion)}</span>
      userId:
      <span style={{ margin: '0 5px' }} className={'envUserId'}>
        {user.userId}
      </span>
      userName:
      <span className={'envUserName'} style={{ margin: '0 5px' }}>
        {user.userName}
      </span>
      abTag:
      <span style={{ margin: '0 5px' }}>{JSON.stringify(abTag)}</span>
    </EnvBar>
  );
});
